import { PropsWithChildren } from "react";
import { Box, Link, LinkProps } from "@mui/material";

export interface IOptionalLinkProps extends Omit<LinkProps, "href"> {
    href: string | null | undefined;
}

export const OptionalLink = ({ href, children, "aria-label": ariaLabel, ...linkProps }: PropsWithChildren<IOptionalLinkProps>) => {
    if (!href) {
        return <>{children}</>;
    }

    return (
        <Link href={href} aria-label={ariaLabel} {...linkProps}>
            {ariaLabel ? (
                <Box component="span" aria-hidden sx={{ display: "contents" }}>
                    {children}
                </Box>
            ) : (
                children
            )}
        </Link>
    );
};
